module.exports = __webpack_public_path__ + "static/media/pc_empty.963fd707.png";